module.exports = __webpack_public_path__ + "media/images/landing_page/majaslapa-preview-a4b1e867c9550a9f9e52e970fa630be8.png";